import { render, staticRenderFns } from "./VaimoVideoPlayer.vue?vue&type=template&id=1a5d0caa&"
import script from "./VaimoVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./VaimoVideoPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports